export const isCrmDataCitation = source => {
  return source.__typename === 'com.hubspot.custom.enrichment.models.CrmDataCitationBase';
};
export const isWebDataCitation = source => {
  return source.__typename === 'com.hubspot.custom.enrichment.models.WebDataCitation';
};
export const isCallTranscriptCitation = source => {
  return source.__typename === 'com.hubspot.custom.enrichment.models.CallTranscriptCitation';
};